import { WeightChartData } from "../types/WeightChartData";

/**
 * Get an array of numbers as tick values.
 * This will get the weight values of the lineChartData and then add 2
 * before the lowest value and after the highest value so the line will not hit the extremes
 * @param lineChartData
 * @returns
 */
export const getTickValues = (lineChartData: WeightChartData[]): number[] => {
  const yTickValues = lineChartData
    .map((log) => log.weight)
    .filter(isDefined)
    .sort((a, b) => a - b) || [0];
  if (yTickValues.length !== 0) {
    yTickValues.unshift(yTickValues[0] - 2);
    yTickValues.push(yTickValues[yTickValues.length - 1] + 2);
  }
  return yTickValues;
};

function isDefined<T>(value: T | null | undefined): value is T {
  return value != null;
}
